import {Model} from 'backbone';

// type Store = {
//     getItem: String -> String
//     setItem: String -> String -> ()
// }

// getFlags :: Store -> {}
export const getFlags = store => {
    const data = store.getItem('flags');
    try {
        return JSON.parse(data) || {};
    } catch (e) {
        return {};
    }
};

// setFlags :: Store -> {} -> Store
export const setFlags = (store, flags) => {
    store.setItem('flags', JSON.stringify(flags));
    return store;
};

const DebugModel = Model.extend({
    defaults: {
        buildNumber: 'No build info found',
        microServiceVersion: '',
        version: '',
        authorMode: false,
        environment: 'Live',
        envGroup: 'Live',
        staging: false,
        activeThru: 'Live',
        cdnAtPrefix: '',
        cssRefs: ['/assets/compiled_css/sd-components.css'],
        stagingContentRenderer: '*.sinclairstoryline.com',
        liveContentRenderer: '*.sinclairstoryline.com',
        Live: {},
        Test: {},
        Dev: {},
    },
    initialize(data) {
        this.overrides = getFlags(localStorage);
        return this.set(data);
    },
    getFeatureFlag(flag) {
        if (flag in this.overrides) {
            return this.overrides[flag];
        }
        const activeThru = this.get('activeThru');

        return this.get(activeThru)[flag];
    },
    setFeatureFlag(flag, isOn) {
        const activeThru = this.get('activeThru');
        this.overrides[flag] = isOn;
        setFlags(localStorage, this.overrides);
        this.attributes[activeThru][flag] = !!isOn;
    },
});

export default DebugModel;
